module.exports = __webpack_public_path__ + "static/media/narrator.e23232f0.ico";